module.exports = __webpack_public_path__ + "04_glasses_red.acb66fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/04_glasses_red.png
// module id = tHOG
// module chunks = 0